import React from "react";
import {getCharacterDatabaseData} from "../includes/axios/getCharacterDatabaseData.js";
import "./alphabet.css";
import { withRouter } from 'react-router-dom';
import {Provider, connect} from "react-redux";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router} from "react-router-dom";
import { createBrowserHistory } from 'history';

var Alphabet = class Alphabet extends React.Component{
    
    constructor(props) {
        super(props);
        this.alphabetArray = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
        this.changeCharacterDatabase = this.props.changeCharacterDatabase;
        this.showCharacterDatabase = this.props.showCharacterDatabase;
        this.changePaginationOffset = this.props.changePaginationOffset;
        this.changeCharacterLetter = this.props.changeCharacterLetter;     
      
      }  



    componentDidMount(){
      //THIS IS CALLED IN APP.js at the start of the project. otherwise if called from here, it gets fired twice
      //everytime a letter is clicked.
        //this.switchPageNumber(this.props.pagination.currentLetter,this.props.pagination.currentPage,0);
    }//end componentDidMount()
    
    //not the same as switchPageNumber() in pagination.js. Slightly different
    switchPageNumber(letter,currentPage,offset){
      
      getCharacterDatabaseData(letter,offset,this.props.changeCharacterDatabase,this.props.showCharacterDatabase,this.props.changePaginationOffset,this.props.changeCharacterLetter);
      this.props.changePaginationPage(currentPage);
    }

    render() {
      const routeBase = localStorage.getItem("routeBase"); 
      
      return (
        <div className="alphabetWrapper">
          <div className="alphabetContainer">{
              this.alphabetArray.map(function(letter,index){ 
                var urlParam = routeBase + "/characterDatabase/page1";
                if(this.props.pagination.currentLetter === letter){ 
                  
                  return <Link to={urlParam} key={index} >
                    <div className="letter highlighted"
                            key={index} 
                            //this offset will always be Zero since youre grabbing it based on letter
                            onClick = {()=>{this.switchPageNumber(letter,1,0)}}
                          >
                            {letter}
                          </div>
                        </Link>
                }
                else{
                  return <Link to={urlParam} key={index} >
                      <div className="letter"
                            key={index} 
                            //this offset will always be Zero since youre grabbing it based on letter
                            onClick = {()=>{this.switchPageNumber(letter,1,0)}}
                          >
                            {letter}
                          </div> 
                      </Link>                     
                }
              },this)
              }
          </div>
        </div>
      );
    }
  }

  export default Alphabet;


// WEBPACK FOOTER //
// ./src/components/alphabet/alphabet.js